import PropTypes from "prop-types"

const measurePropType = PropTypes.shape({
  description: PropTypes.string,
  price: PropTypes.number,
  quantity: PropTypes.number,
  type: PropTypes.number,
  unity: PropTypes.string,
})

const certItemPropType = PropTypes.shape({
  partidaId: PropTypes.string,
  measure_date: PropTypes.string,
  certificationId: PropTypes.string,
  invoiced_amount: PropTypes.number,
  invoice_amount_pending: PropTypes.number,
  measure_total: PropTypes.number,
  measure_delta: PropTypes.number,
})

const partPropType = PropTypes.shape({
  accountId: PropTypes.string,
  certCurrent: PropTypes.number,
  certPrevious: PropTypes.number,
  chapterId: PropTypes.string,
  clientPrice: PropTypes.number,
  clientPriceWithoutDiscount: PropTypes.number,
  invoicedAmount: PropTypes.number,
  invoiceAmountPending: PropTypes.number,
  code: PropTypes.string,
  comment: PropTypes.string,
  costeGeneral: PropTypes.number,
  costeIndirecto: PropTypes.number,
  createdAt: PropTypes.string,
  decomposition: PropTypes.oneOfType([
    PropTypes.arrayOf(measurePropType),
    PropTypes.any,
  ]),
  description: PropTypes.string,
  discount: PropTypes.number,
  files: PropTypes.arrayOf(PropTypes.object),
  industrialProfit: PropTypes.number,
  marginsEdited: PropTypes.string,
  measures: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        depth: PropTypes.number,
        description: PropTypes.string,
        height: PropTypes.number,
        quantity: PropTypes.number,
        width: PropTypes.number,
      }),
    ),
    PropTypes.any,
  ]),
  name: PropTypes.string,
  overage: PropTypes.number,
  partidaId: PropTypes.string,
  position: PropTypes.number,
  price: PropTypes.number,
  projectId: PropTypes.string,
  quantity: PropTypes.number,
  refPrice: PropTypes.number,
  sended: PropTypes.string,
  unity: PropTypes.string,
  updatedAt: PropTypes.string,
  cert: certItemPropType,
})

const chapterPropType = PropTypes.shape({
  accountId: PropTypes.string,
  chapterId: PropTypes.string,
  chaptersCount: PropTypes.number,
  clientPrice: PropTypes.number,
  clientPriceWithoutDiscount: PropTypes.number,
  createdAt: PropTypes.string,
  name: PropTypes.string,
  organizationId: PropTypes.string,
  parentId: PropTypes.string,
  partsCount: PropTypes.number,
  position: PropTypes.number,
  price: PropTypes.number,
  projectId: PropTypes.string,
  selfManagement: PropTypes.string,
  sended: PropTypes.string,
  updatedAt: PropTypes.string,
  chapters: PropTypes.oneOfType([
    // PropTypes.arrayOf(chapterPropType),
    PropTypes.any,
  ]),
  parts: PropTypes.oneOfType([PropTypes.arrayOf(partPropType), PropTypes.any]),
})

const certificationPropType = PropTypes.shape({
  id: PropTypes.string,
  status: PropTypes.string,
  revisionDate: PropTypes.string,
  certificationUserId: PropTypes.string,
  certItems: PropTypes.objectOf(certItemPropType),
  chapters: PropTypes.oneOfType([
    PropTypes.arrayOf(chapterPropType),
    PropTypes.any,
  ]),
})

export {
  measurePropType,
  certItemPropType,
  partPropType,
  chapterPropType,
  certificationPropType,
}
